const defaultPaymentMethod = 'visa_mastercard';

// Fixed attributes of the official CGA seal markup. The link and image URLs come
// from brand config (footerLicenses); the image must load straight from cga.cw.
const cgaSeal = {
  alt: 'Curaçao Gaming Authority license — verify at cga.cw',
  height: '64',
};

export { defaultPaymentMethod, cgaSeal };
